import styled from 'styled-components'

export const StyledFileSection = styled.div<{ $primaryColor: string }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #dee2e6;
  margin-bottom: 1rem;

  .file-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: ${props => props.$primaryColor || '#a03'};
    border-radius: 8px;
    color: white;
    flex-shrink: 0;
  }

  .file-info {
    flex: 1;
    min-width: 0;

    .file-label {
      font-size: 0.75rem;
      color: #6c757d;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 0.25rem;
    }

    .file-name {
      font-weight: 500;
      color: #212529;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.clickable {
        cursor: pointer;
        &:hover {
          color: ${props => props.$primaryColor || '#a03'};
          text-decoration: underline;
        }
      }
    }

    .file-placeholder {
      color: #adb5bd;
      font-style: italic;
    }
  }

  .file-actions {
    flex-shrink: 0;
  }
`

export const DocumentList = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`

export const DocumentItem = styled.div`
  display: flex;
  width: 300px;
  min-width: 200px;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 10px;
  border: 1px solid #dcdfe4;
  border-radius: 12px;
  background: #fff;

  .left {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
  }

  .icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon i {
    margin: 0;
    color: #6b7280;
  }
`

export const FileInfo = styled.div`
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 4px;
  }
`

export const FileMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: #6b7280;
  font-size: 14px;
`

export const FileType = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef1f4;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
`